import { render, staticRenderFns } from "./ifrs9.vue?vue&type=template&id=058effb5&scoped=true&"
import script from "./ifrs9.vue?vue&type=script&lang=js&"
export * from "./ifrs9.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/bootstrap.css?vue&type=style&index=0&id=058effb5&scoped=true&lang=css&"
import style1 from "./ifrs9.vue?vue&type=style&index=1&id=058effb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058effb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
